import { Component, OnInit, OnDestroy, ViewChildren, QueryList, ElementRef, ChangeDetectorRef } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Router } from "@angular/router";

import { WriteUsComponent } from "../pop-ups/write-us/write-us.component";
import {knowledgeMenu} from "../../utils/data/knowledge";
import { CommonDataService } from "../../shared/services/common-data.service";
import { environment } from '../../../environments/environment.prod'
import { RedirectionService } from "@root/shared/services/redirection.service";

@Component({
  selector: "app-knowledge-center",
  templateUrl: "./knowledge-center.component.html",
  styleUrls: ["./knowledge-center.component.scss"],
})
export class KnowledgeCenterComponent implements OnInit, OnDestroy {
  activeTabId = 0;
  @ViewChildren('knowledgeTab')
knowledgeTabs!: QueryList<ElementRef>;
  showFull = false;
  liveMessage = '';
  showTabs = true;
  activeTopicId = 0;
  tabsList: any;
  pageUrl: any;

  constructor(
    private modalService: NgbModal,
    public commonDataService: CommonDataService,
    public router: Router,
    private activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private redirectionService : RedirectionService
  ) {}

  ngOnInit() {
    this.tabsList = knowledgeMenu;
    this.pageUrl = location.href;
    this.scrollTop();
    this.activatedRoute.queryParams.subscribe((qParam) => {
      const context = qParam["context"];
      switch (context) {
        case "Intermediate":
          this.activeTopicId = 1;
          this.setActive(this.activeTopicId, context);
          break;
        case "Advanced":
          this.activeTopicId = 2;
          this.setActive(this.activeTopicId, "Professional");
          break;
        default:
          this.activeTopicId = 0;
      }
    });
  }

  scrollTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  // setActive = (id:number, val:any) => {
  //   this.activeTabId = id;
  // };
  setActive(id: number, displayName: string) {
  this.activeTabId = id;
  this.showFull = false;

  this.liveMessage = '';

  setTimeout(() => {
    this.liveMessage =
      `${displayName} articles loaded.`;
  }, 100);
}

  // setActiveSubTab = (id:any) => {
  //   this.activeTopicId = id;
  //   this.showTabs = false;

  //   const obj = {
  //     val: this.tabsList[this.activeTabId].displayName,
  //     position: "large",
  //     heading: true,
  //   };
  //   this.commonDataService.setSubBreadCrumb(obj);
  // };
  setActiveSubTab(id: number) {
  this.activeTopicId = id;
  this.showTabs = false;

  this.liveMessage = '';

  setTimeout(() => {
    this.liveMessage =
      `${this.tabsList[this.activeTabId].topics[id].question} article opened.`;
  }, 100);
}
  setActiveTopic = (id:number) => {
    this.activeTopicId = id;
  };

  // goBack = () => {
  //   this.showTabs = true;
  //   this.removeBreadCrumb();
  // };
  goBack() {
  this.showTabs = true;

  this.liveMessage = '';

  setTimeout(() => {
    this.liveMessage =
      `${this.tabsList[this.activeTabId].displayHeading} articles loaded.`;
  }, 100);
}

  openPopUp = () => {
    this.modalService.open(WriteUsComponent, {
      size: "lg",
      windowClass: "align-modal-center",
    });
  };

  removeBreadCrumb = () => {
    this.commonDataService.setSubBreadCrumb(null);
  };

  showAllArticles() {
  this.showFull = true;

  this.liveMessage = '';

  setTimeout(() => {
    this.liveMessage = 'All articles displayed.';
  }, 100);
}

showLessArticles() {
  this.showFull = false;

  this.liveMessage = '';

  setTimeout(() => {
    this.liveMessage = 'Articles collapsed.';
  }, 100);
}

  mobileNav = (url:any) => {
    this.router.navigate([url]);
  };

  investOnline = () => {
    this.redirectionService.redirectToInvestorPortal();
    // if(!environment.isDRBuild){
    //   window.open("https://investonline.itiamc.com/", "_blank");
    // }else{
    //   window.open("https://investonline.itiamc.com/", "_blank"); //DR-inv
    // }
  };

  ngOnDestroy() {
    this.commonDataService.setSubBreadCrumb(null);
  }

  private focusTab(index: number): void {

  this.cdr.detectChanges();

  requestAnimationFrame(() => {
    this.knowledgeTabs.get(index)?.nativeElement.focus();
  });

}

onVerticalKeydown(event: KeyboardEvent, index: number) {

  let nextIndex = index;

  switch (event.key) {

    case 'ArrowDown':
      event.preventDefault();
      nextIndex = Math.min(index + 1, this.tabsList.length - 1);
      break;

    case 'ArrowUp':
      event.preventDefault();
      nextIndex = Math.max(index - 1, 0);
      break;

    case 'Home':
      event.preventDefault();
      nextIndex = 0;
      break;

    case 'End':
      event.preventDefault();
      nextIndex = this.tabsList.length - 1;
      break;

    case 'Enter':
    case ' ':
      event.preventDefault();
      this.setActive(index, this.tabsList[index].displayName);
      return;

    default:
      return;
  }

  this.setActive(nextIndex, this.tabsList[nextIndex].displayName);
  this.focusTab(nextIndex);

}
}
